export const comics = [
  {
    id: 1,
    slug: "yehua-jiangjun",
    title: "夜画将军",
    author: "金明智",
    category: "古风恋爱",
    rating: 9.5,
    latestChapter: "第128话",
    updateDate: "2026-07-02",
    cover: "https://readdy.ai/api/search-image?query=Elegant%20Korean%20manhwa%20art%20style%2C%20historical%20romance%20genre%2C%20beautiful%20female%20character%20in%20traditional%20hanbok%20dress%2C%20soft%20pastel%20color%20palette%2C%20dreamy%20atmosphere%2C%20delicate%20linework%2C%20flower%20petals%20floating%2C%20warm%20golden%20lighting%2C%20clean%20simple%20background%20with%20subtle%20gradient%2C%20professional%20manhwa%20cover%20illustration%2C%20high%20quality%20anime%20style%20art&width=800&height=1067&seq=comic-cover-01&orientation=portrait",
    description: "将军府的大小姐在一次偶然中救下神秘刺客，从此命运纠缠。朝堂风云变幻，家国仇恨与儿女情长交织，一段跨越身份与仇恨的凄美爱情故事。",
    tags: ["古风", "恋爱", "权谋", "虐心"],
    views: 2350000,
  },
  {
    id: 2,
    slug: "anying-shenpan",
    title: "暗影审判",
    author: "Carnby Kim",
    category: "悬疑惊悚",
    rating: 9.7,
    latestChapter: "第95话",
    updateDate: "2026-07-01",
    cover: "https://readdy.ai/api/search-image?query=Dark%20thriller%20Korean%20manhwa%20style%2C%20mysterious%20male%20protagonist%20in%20black%20suit%2C%20noir%20atmosphere%2C%20dramatic%20lighting%20with%20deep%20shadows%2C%20urban%20night%20cityscape%20background%2C%20intense%20moody%20color%20scheme%20with%20red%20accents%2C%20professional%20manhwa%20cover%20art%2C%20clean%20composition%2C%20high%20contrast%20illustration&width=800&height=1067&seq=comic-cover-02&orientation=portrait",
    description: "一名拥有读心术能力的检察官，在追查连环杀人案时发现自己成为凶手的下一个目标。真相如同暗影，越靠近越令人窒息。年度悬疑神作，反转不断。",
    tags: ["悬疑", "犯罪", "超能力", "反转"],
    views: 4120000,
  },
  {
    id: 3,
    slug: "tianshi-zhiyue",
    title: "天使之约",
    author: "李秀贤",
    category: "浪漫爱情",
    rating: 9.3,
    latestChapter: "第210话",
    updateDate: "2026-07-02",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20Korean%20manhwa%20style%2C%20young%20couple%20holding%20hands%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20and%20white%20color%20palette%2C%20spring%20atmosphere%2C%20gentle%20sunlight%20filtering%20through%20petals%2C%20sweet%20and%20dreamy%20mood%2C%20clean%20pastel%20background%2C%20professional%20manhwa%20cover%20illustration%2C%20delicate%20shojo%20style%20art&width=800&height=1067&seq=comic-cover-03&orientation=portrait",
    description: "钢琴天才少女遇上街头音乐少年，两个世界的灵魂在音符中相遇。从校园到舞台，他们用音乐书写最动人的青春恋曲。甜蜜治愈，每一页都让人心动。",
    tags: ["校园", "音乐", "恋爱", "治愈"],
    views: 5280000,
  },
  {
    id: 4,
    slug: "xingkong-lieche",
    title: "星空列车",
    author: "朴星河",
    category: "奇幻冒险",
    rating: 9.6,
    latestChapter: "第72话",
    updateDate: "2026-06-30",
    cover: "https://readdy.ai/api/search-image?query=Fantasy%20adventure%20Korean%20manhwa%20style%2C%20young%20hero%20with%20sword%20standing%20on%20floating%20train%20in%20starry%20sky%2C%20magical%20celestial%20background%20with%20constellations%2C%20vibrant%20deep%20blue%20and%20gold%20color%20scheme%2C%20epic%20scale%2C%20professional%20manhwa%20cover%20art%2C%20clean%20composition%2C%20beautiful%20illustration&width=800&height=1067&seq=comic-cover-04&orientation=portrait",
    description: "一列穿越星空的魔法列车，承载着来自不同世界的乘客。少年为了寻找失踪的妹妹，踏上了这趟没有终点的旅程。每一站是一个新世界，每一站都有新的冒险。",
    tags: ["奇幻", "冒险", "热血", "治愈"],
    views: 3150000,
  },
  {
    id: 5,
    slug: "milian-fandian",
    title: "秘恋饭店",
    author: "韩智恩",
    category: "浪漫爱情",
    rating: 9.1,
    latestChapter: "第156话",
    updateDate: "2026-07-02",
    cover: "https://readdy.ai/api/search-image?query=Luxury%20hotel%20romance%20Korean%20manhwa%20style%2C%20elegant%20female%20chef%20and%20handsome%20hotel%20manager%20in%20sophisticated%20setting%2C%20warm%20candlelit%20atmosphere%2C%20champagne%20gold%20and%20cream%20color%20palette%2C%20classy%20and%20romantic%20mood%2C%20professional%20manhwa%20cover%20art%2C%20clean%20composition%2C%20high%20end%20illustration&width=800&height=1067&seq=comic-cover-05&orientation=portrait",
    description: "顶级酒店的明星主厨与神秘CEO之间不能公开的秘密恋情。在米其林厨房的烟火气中，爱情如同精心烹调的料理，需要耐心与火候。",
    tags: ["都市", "职场", "恋爱", "美食"],
    views: 1890000,
  },
  {
    id: 6,
    slug: "huanmie-jitan",
    title: "幻灭祭坛",
    author: "尹在浩",
    category: "悬疑惊悚",
    rating: 9.4,
    latestChapter: "第63话",
    updateDate: "2026-07-01",
    cover: "https://readdy.ai/api/search-image?query=Horror%20mystery%20Korean%20manhwa%20style%2C%20ancient%20stone%20altar%20in%20dark%20forest%2C%20eerie%20atmosphere%20with%20mist%20and%20candlelight%2C%20female%20protagonist%20with%20fearful%20expression%2C%20cold%20blue%20and%20dark%20gray%20color%20scheme%2C%20supernatural%20horror%20theme%2C%20professional%20manhwa%20cover%20art%2C%20clean%20composition&width=800&height=1067&seq=comic-cover-06&orientation=portrait",
    description: "一座被诅咒的村庄，一座禁忌的祭坛。女大学生意外卷入百年祭祀仪式，发现自己的身世与这场仪式有着千丝万缕的联系。恐怖与悬疑层层递进。",
    tags: ["恐怖", "悬疑", "民俗", "推理"],
    views: 2780000,
  },
  {
    id: 7,
    slug: "zuanshi-wangzuo",
    title: "钻石王座",
    author: "崔元英",
    category: "古风恋爱",
    rating: 9.2,
    latestChapter: "第189话",
    updateDate: "2026-07-02",
    cover: "https://readdy.ai/api/search-image?query=Royal%20palace%20romance%20Korean%20manhwa%20style%2C%20queen%20in%20luxurious%20traditional%20royal%20gown%20with%20diamond%20crown%2C%20magnificent%20palace%20interior%20background%2C%20rich%20gold%20and%20crimson%20color%20palette%2C%20dramatic%20and%20elegant%20atmosphere%2C%20professional%20manhwa%20cover%20art%2C%20clean%20composition%2C%20high%20quality%20illustration&width=800&height=1067&seq=comic-cover-07&orientation=portrait",
    description: "平民少女阴差阳错成为王妃，在后宫权谋中步步为营。爱情与权力的博弈，她能否守住自己的真心和这个摇摇欲坠的王座？大气磅礴的后宫传奇。",
    tags: ["宫廷", "恋爱", "权谋", "逆袭"],
    views: 3670000,
  },
  {
    id: 8,
    slug: "jixian-zhiye",
    title: "极限职业",
    author: "张东秀",
    category: "搞笑日常",
    rating: 9.0,
    latestChapter: "第201话",
    updateDate: "2026-07-03",
    cover: "https://readdy.ai/api/search-image?query=Comedy%20slice%20of%20life%20Korean%20manhwa%20style%2C%20funny%20office%20workers%20in%20chaotic%20workplace%2C%20bright%20and%20colorful%20art%20style%2C%20exaggerated%20facial%20expressions%2C%20vibrant%20yellow%20and%20orange%20color%20scheme%2C%20humorous%20and%20lively%20atmosphere%2C%20professional%20manhwa%20cover%20art%2C%20clean%20composition&width=800&height=1067&seq=comic-cover-08&orientation=portrait",
    description: "五个不同行业的打工人，五种爆笑生存法则。从程序员到外卖骑手，每个职业都有说不完的辛酸和笑料。笑着笑着就哭了，哭着哭着又笑了。",
    tags: ["搞笑", "日常", "职场", "治愈"],
    views: 4560000,
  },
  {
    id: 9,
    slug: "mofa-shaonv-chengzhangji",
    title: "魔法少女成长记",
    author: "金美英",
    category: "奇幻冒险",
    rating: 9.3,
    latestChapter: "第134话",
    updateDate: "2026-06-29",
    cover: "https://readdy.ai/api/search-image?query=Magical%20girl%20transformation%20Korean%20manhwa%20style%2C%20young%20witch%20with%20magical%20staff%20and%20sparkling%20effects%2C%20whimsical%20fantasy%20world%20background%20with%20floating%20islands%2C%20bright%20pastel%20purple%20and%20pink%20color%20scheme%2C%20enchanting%20and%20cute%20atmosphere%2C%20professional%20manhwa%20cover%20art%2C%20clean%20composition&width=800&height=1067&seq=comic-cover-09&orientation=portrait",
    description: "平凡初中生意外获得魔法力量，在魔法学院展开奇妙冒险。友情、成长与魔法的交织，一部温暖人心的青春奇幻物语。",
    tags: ["魔法", "校园", "成长", "友情"],
    views: 1920000,
  },
  {
    id: 10,
    slug: "heibang-laoda-de-nu'er",
    title: "黑帮老大的女儿",
    author: "赵贤雅",
    category: "搞笑日常",
    rating: 9.5,
    latestChapter: "第178话",
    updateDate: "2026-07-03",
    cover: "https://readdy.ai/api/search-image?query=Comedy%20action%20Korean%20manhwa%20style%2C%20tough%20girl%20in%20school%20uniform%20with%20confident%20smirk%2C%20contrast%20between%20cute%20appearance%20and%20gangster%20background%2C%20bright%20school%20setting%20with%20comedic%20elements%2C%20vibrant%20teal%20and%20white%20color%20scheme%2C%20fun%20and%20energetic%20atmosphere%2C%20professional%20manhwa%20cover%20art&width=800&height=1067&seq=comic-cover-10&orientation=portrait",
    description: "全国最大黑帮组织的独生女转学到普通高中，立志过平凡生活，但她的「平凡」似乎和普通人不太一样。爆笑与热血并存的校园喜剧。",
    tags: ["校园", "搞笑", "动作", "反差萌"],
    views: 3920000,
  },
  {
    id: 11,
    slug: "dushi-lieren",
    title: "都市猎人",
    author: "姜道贤",
    category: "悬疑惊悚",
    rating: 9.6,
    latestChapter: "第88话",
    updateDate: "2026-07-02",
    cover: "https://readdy.ai/api/search-image?query=Action%20thriller%20Korean%20manhwa%20style%2C%20vigilante%20hero%20in%20dark%20hoodie%20on%20rooftop%20at%20night%2C%20neon%20lit%20city%20skyline%20background%2C%20intense%20and%20gritty%20atmosphere%2C%20dark%20blue%20and%20neon%20pink%20color%20scheme%2C%20dynamic%20composition%2C%20professional%20manhwa%20cover%20art&width=800&height=1067&seq=comic-cover-11&orientation=portrait",
    description: "白天是普通上班族，夜晚化身正义的都市猎人。他用自己的方式惩戒法律无法制裁的恶人。当复仇成为习惯，他还能分清正义与私欲的界限吗？",
    tags: ["动作", "犯罪", "正义", "悬疑"],
    views: 3450000,
  },
  {
    id: 12,
    slug: "shiguang-lvxingzhe",
    title: "时光旅行者",
    author: "李恩在",
    category: "奇幻冒险",
    rating: 9.8,
    latestChapter: "第55话",
    updateDate: "2026-07-01",
    cover: "https://readdy.ai/api/search-image?query=Time%20travel%20fantasy%20Korean%20manhwa%20style%2C%20protagonist%20between%20past%20and%20future%20worlds%2C%20clock%20gears%20and%20time%20portal%20visual%20effects%2C%20split%20composition%20showing%20two%20different%20eras%2C%20warm%20sepia%20and%20cool%20silver%20color%20contrast%2C%20mysterious%20and%20emotional%20atmosphere%2C%20professional%20manhwa%20cover%20art&width=800&height=1067&seq=comic-cover-12&orientation=portrait",
    description: "拥有穿越时间能力的少年，每一次跳跃都是为了拯救心爱之人。但改变过去需要付出代价，他发现自己正在慢慢从所有人的记忆中消失。催泪神作。",
    tags: ["穿越", "奇幻", "治愈", "催泪"],
    views: 5010000,
  },
];

export const categories = [
  { slug: "langman-aiqing", name: "浪漫爱情", count: 256, icon: "ri-heart-line" },
  { slug: "xunyi-jingsong", name: "悬疑惊悚", count: 183, icon: "ri-ghost-line" },
  { slug: "gufeng-lianai", name: "古风恋爱", count: 142, icon: "ri-ancient-gate-line" },
  { slug: "qihuan-maoxian", name: "奇幻冒险", count: 198, icon: "ri-rocket-line" },
  { slug: "gaoxiao-richang", name: "搞笑日常", count: 167, icon: "ri-emotion-laugh-line" },
  { slug: "xiaoyuan-qingchun", name: "校园青春", count: 134, icon: "ri-school-line" },
  { slug: "renexue-dongzuo", name: "热血动作", count: 145, icon: "ri-fire-line" },
  { slug: "dushi-zhi'ai", name: "都市职场", count: 112, icon: "ri-building-line" },
];

export const testimonials = [
  {
    quote: "韩漫屋是我每天必刷的漫画平台，更新速度真的很快，画质也超级清晰。推荐给所有喜欢韩漫的朋友！",
    author: "小雨",
    role: "资深漫迷",
    avatar: "https://readdy.ai/api/search-image?query=Pretty%20young%20Asian%20woman%20portrait%2C%20soft%20natural%20lighting%2C%20warm%20smile%2C%20simple%20cream%20background%2C%20professional%20headshot%20style%2C%20clean%20and%20minimal%20composition&width=200&height=200&seq=avatar-01&orientation=squarish",
  },
  {
    quote: "在这个平台上发现了好多宝藏漫画，分类很清晰，找漫画特别方便。而且完全免费，良心平台！",
    author: "阿明",
    role: "漫画博主",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%2C%20friendly%20expression%2C%20casual%20style%2C%20clean%20light%20gray%20background%2C%20professional%20headshot%2C%20simple%20and%20natural%20composition&width=200&height=200&seq=avatar-02&orientation=squarish",
  },
  {
    quote: "界面简洁美观，没有任何烦人的广告弹窗，阅读体验一级棒。上班摸鱼必备神器，嘿嘿。",
    author: "小琳",
    role: "上班族漫迷",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20with%20glasses%20portrait%2C%20gentle%20smile%2C%20office%20casual%20look%2C%20simple%20warm%20beige%20background%2C%20professional%20headshot%20style%2C%20clean%20composition&width=200&height=200&seq=avatar-03&orientation=squarish",
  },
];

export const stats = [
  { value: "5000+", label: "漫画资源" },
  { value: "100万+", label: "月活用户" },
  { value: "98%", label: "好评率" },
  { value: "30秒", label: "平均加载" },
];

export const faqs = [
  {
    question: "韩漫屋上的漫画都是免费的吗？",
    answer: "是的！韩漫屋所有漫画均可免费在线阅读，无需付费订阅。我们致力于为广大漫迷提供高质量的免费漫画资源，让每个人都能享受阅读的乐趣。",
  },
  {
    question: "多久更新一次漫画章节？",
    answer: "我们与多家韩国漫画平台保持合作，热门连载漫画通常每周更新1-2话，确保您能第一时间追到最新内容。更新时间为每天上午10点和晚上8点。",
  },
  {
    question: "可以在手机上阅读吗？",
    answer: "当然可以！韩漫屋采用响应式设计，完美适配手机、平板和电脑等各种设备。无论您使用什么设备，都能获得流畅的阅读体验。我们还支持横屏和竖屏双模式阅读。",
  },
  {
    question: "如何找到我想看的漫画？",
    answer: "您可以通过首页的分类导航、搜索功能或排行榜来发现漫画。我们提供按类型、人气、评分等多种筛选方式，帮助您快速找到感兴趣的漫画作品。",
  },
  {
    question: "漫画的翻译质量怎么样？",
    answer: "我们拥有专业的韩语翻译团队，所有漫画都经过严格的翻译和校对流程，确保中文翻译准确流畅，同时保留原作的意境和风格。",
  },
];